module.exports = "\n";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/status-bar/status-bar.component.html
// module id = 1867
// module chunks = 1